import type { Session } from "@supabase/supabase-js";
import { create } from "zustand";
import { onSessionUser } from "./forget.ts";
import { supabase } from "./supabase.ts";

export interface MyProfile {
  id: string;
  display_name: string;
  minor_status: string;
  /** active, suspended, banned ou deleted : seul un compte actif peut agir (la base le vérifie). */
  account_status: string;
  onboarding_completed_at: string | null;
}

interface SessionState {
  session: Session | null;
  profile: MyProfile | null;
  loading: boolean;
  refreshProfile: () => Promise<void>;
}

export const useSession = create<SessionState>((set, get) => ({
  session: null,
  profile: null,
  loading: true,
  refreshProfile: async () => {
    const uid = get().session?.user.id;
    if (!uid) return set({ profile: null });
    const { data } = await supabase
      .from("profiles")
      .select("id, display_name, minor_status, account_status, onboarding_completed_at")
      .eq("id", uid)
      .maybeSingle();
    set({ profile: (data as MyProfile | null) ?? null });
  },
}));

export function initSession() {
  void supabase.auth.getSession().then(async ({ data }) => {
    // Un téléphone se prête : ce qui reste d'un autre compte est effacé avant d'afficher quoi que ce soit.
    onSessionUser(data.session?.user.id ?? null);
    useSession.setState({ session: data.session, loading: false });
    await useSession.getState().refreshProfile();
  });
  supabase.auth.onAuthStateChange((_event, session) => {
    onSessionUser(session?.user.id ?? null);
    useSession.setState({ session });
    void useSession.getState().refreshProfile();
  });
}
